export default __webpack_public_path__ + "assets/images/aistudio/3372a0471c06250989c510efea3c75e0.png";